

const myVariantSelectionFunction = (payload) => {
  const { code, id, displaySize01, displaySize02, codeType } = payload;
  try {
    $(`.block-swatch-list .block-swatch__radio[value=${displaySize01}]`).click();
    $(`.block-swatch-list .block-swatch__radio[value=${displaySize02}]`).click();
    $(`.block-swatch-list .block-swatch__radio[value="(${displaySize01}) ${displaySize02}"]`).click();
    $(`.block-swatch-list .block-swatch__radio[value="${displaySize01} ${displaySize02}"]`).click();
  } catch (error) {
    console.error(error);
  }
};

const showMyButton = (payload) => {
  const { code, id } = payload;
  if(id == "oz-trigger-1" && code){
    $('.find-msiz').show();
  }
  if(id == "oz-trigger-2" && code){
     $('.find-geomet').show();
  }
};

const OZ_CONFIG = {
  settings: {
    apiKey: '$oz_$WGseqZ2ZE4mS04gSY5y7HOImL6rXWn2lxm8cUYANWQ3yUEP8dwmAa',
    container: "my-sizing-container", // the ID of your empty target element, which will then contain the generated iframe element
    primary: '#ffcf07', // colors can be any format accepted by css. Hey, rgb, hsl, …
    cta: 'rgb(255, 207, 7)',
    roundness: '0px'
  },
   events: {
    confirmSize: {
      callback: myVariantSelectionFunction, // don't add parentheses here, otherwise the funtion will execute immediately instead of waiting for invocation
    },
    sizingAvailable: {
      callback: showMyButton,
    }
     
  }
};

((win, doc, script, key, config, src) => {
    win['___OnlineSizing'] = key;
    win['___OnlineSizingConfig'] = config;
    const js = doc.createElement(script);
    js.id = key;
    js.src = src;
    js.async = true;

    const scripts = doc.getElementsByTagName(script);
    const lastScript = scripts[scripts.length - 1];
    lastScript.parentNode.insertBefore(js, lastScript);
})(window, document, 'script', 'oz', OZ_CONFIG, 'https://widgets.onlinesizing.bike/loader.js');
